'use client';
import classes from './ConditionModal.module.css';

import { useRouter } from 'next/navigation';
import { Modal } from 'react-bootstrap';
import Image from 'next/image';

import { X } from 'react-feather';

const AddedToCartModal = (props) => {
	const { cart, show, setShow } = props;

	const router = useRouter();

	const goToCheckoutHandler = () => {
		setShow(false);
		let items = [];
		for (let listing of cart.listings) {
			items.push({ id: listing._id, listingPrice: listing.price });
		}

		localStorage.setItem('checkout', JSON.stringify(items));
		localStorage.removeItem('offerInfo');
		router.push('/checkout');
	};

	return (
		<Modal show={show} onHide={setShow}>
			<section className={classes.modalHeader}>
				<section className={classes.col}>
					<h1 className={classes.modalTitle}>Successfully added to cart</h1>
					<p className={classes.description}>
						{cart.listings.length} item{cart.listings.length > 1 && 's'}
					</p>
				</section>
				<X
					className={classes.modalClose}
					strokeWidth={1}
					onClick={() => setShow(false)}
				/>
			</section>
			<section className={classes.modalBody1}>
				<ul className={classes.conditionList}>
					{!cart.loading &&
						cart.listings.length &&
						cart.listings.map((item, index) => (
							<li
								key={index}
								className={classes.cartItem}
								onClick={() =>
									window.open(
										`/product/${item.kashewId}/${item.title
											.toLowerCase()
											.replace(/[_\W]+/g, '-')
											.replace(/^-+/, '')
											.replace(/-+$/, '')}`,
										'_blank'
									)
								}
							>
								<div style={{ position: 'relative' }}>
									<Image
										width={70}
										height={70}
										src={item.images[0]}
										alt={item.title}
										className={
											item.status !== 'active'
												? classes.itemImgSold
												: classes.itemImg
										}
									/>
									{item.status !== 'active' && (
										<div className={classes.soldBanner}>{'Not available'}</div>
									)}
								</div>
								<div className={classes.itemDescription}>
									<h2 className={classes.itemTitle}>{item.title}</h2>
									<section className={classes.itemDetails}>
										<p className={classes.mute}>Item Price:</p>
										<p className={classes.mute}>${item.price}</p>
									</section>
								</div>
							</li>
						))}
				</ul>
				<section className={classes.total}>
					<p className={classes.totalText}>Total</p>
					<p className={classes.totalText}>
						$
						{cart.listings
							.reduce((acc, item) => {
								return acc + item.price;
							}, 0)
							?.toLocaleString({
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							})}
					</p>
				</section>
				<section className={classes.modalFooter}>
					<button className={classes.btn} onClick={() => setShow(false)}>
						Continue Shopping
					</button>
					<button className={classes.btnDark} onClick={goToCheckoutHandler}>
						Go to Checkout
					</button>
				</section>
			</section>
		</Modal>
	);
};

export default AddedToCartModal;
